'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AreaUrlWatcher = require('./Builder/AreaUrlWatcher');

var _AreaUrlWatcher2 = _interopRequireDefault(_AreaUrlWatcher);

var _BlogUrlWatcher = require('./Blogposts/BlogUrlWatcher');

var _BlogUrlWatcher2 = _interopRequireDefault(_BlogUrlWatcher);

var _HomeUrlWatcher = require('./Homes/HomeUrlWatcher');

var _HomeUrlWatcher2 = _interopRequireDefault(_HomeUrlWatcher);

var _FilterUrlWatcher = require('./Filters/FilterUrlWatcher');

var _FilterUrlWatcher2 = _interopRequireDefault(_FilterUrlWatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_AreaUrlWatcher2.default, props),
      _react2.default.createElement(_BlogUrlWatcher2.default, props),
      _react2.default.createElement(_HomeUrlWatcher2.default, props),
      _react2.default.createElement(_FilterUrlWatcher2.default, props),
      _react2.default.createElement(WrappedComponent, props)
    );
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/UrlWatcher.js
// module id = 264
// module chunks = 0